import { AxiosInstance } from "axios";
import ICredDefense from '../interfaces/prefraud/credDefense/ICredDefense';
import { ApiService } from "../models/Api.model";

enum CredDefenseServiceEnum {
  getByTradeId = "/trade/"
}
export default class CredDefenseService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/cred-defense")
  }

  public getByTradeId = async (tradeId: number): Promise<ICredDefense> => await this.GET(`${CredDefenseServiceEnum.getByTradeId}${tradeId}`)
}



// WEBPACK FOOTER //
// ./src/services/api/CredDefense.service.ts